module.exports = __webpack_public_path__ + "img/icone-empresas-do-simples-nacional.a3801c8c.png";